import { render, staticRenderFns } from "./Reporte-PuntosCanjeados.vue?vue&type=template&id=944e8d1e&scoped=true&"
import script from "./Reporte-PuntosCanjeados.vue?vue&type=script&lang=js&"
export * from "./Reporte-PuntosCanjeados.vue?vue&type=script&lang=js&"
import style0 from "./Reporte-PuntosCanjeados.vue?vue&type=style&index=0&id=944e8d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e8d1e",
  null
  
)

export default component.exports